/* Referral Program Config — Frontend ("Founding Manager Unlocks")
 *
 * MIRRORS backend/src/config/referralProgram.js. This copy only controls what
 * the UI shows — the waitlist page's reward ladder and the in-app unlock
 * checks. It is NOT the security boundary (the backend enforces the real rule
 * in requireTool — see backend/src/middleware/planAccessMiddleware.js). If
 * you change a tier, update BOTH files.
 *
 * The ladder:
 *   1 referral  → Trash Talk unlocked early
 *   3 referrals → Power Rankings unlocked + "Founding Manager" badge
 *   5 referrals → locked-in founder pricing (details announced at launch)
 *
 * `toolId` values match the route slugs in config/hiddenTools.js, so the
 * unlock check in HiddenRoute can compare them directly.
 */

export const REFERRAL_TIERS = [
  {
    tier: 1,
    referralsNeeded: 1,
    toolId: 'trash-talk',
    title: 'Trash Talk',
    detail: 'AI-generated smack talk for your league chat — unlocked before anyone else gets it.',
  },
  {
    tier: 2,
    referralsNeeded: 3,
    toolId: 'power-rankings',
    title: 'Power Rankings + Founding Manager badge',
    detail: 'League-wide power rankings, plus a badge that marks you as here before launch.',
  },
  {
    tier: 3,
    referralsNeeded: 5,
    toolId: null,
    title: 'Founder pricing, locked in',
    detail: 'A founding-member rate on JAI when we launch — details announced at launch.',
  },
]

// Same shape the backend's referral-status endpoints return, computed locally
// when only a count is available (keeps the ladder rendering even if a status
// request fails after a successful join).
export const referralPerksForCount = (count = 0) => {
  const reached = REFERRAL_TIERS.filter((t) => count >= t.referralsNeeded)
  const nextTier = REFERRAL_TIERS.find((t) => count < t.referralsNeeded) || null
  return {
    unlockedTools: reached.filter((t) => t.toolId).map((t) => t.toolId),
    currentTier: reached.length ? reached[reached.length - 1].tier : 0,
    nextTier,
  }
}
